import { Grid, styled, useMediaQuery, useTheme } from '@material-ui/core';
import { SdmSpacer, SdmTypography } from 'components';
import { LoaderContext } from 'context/LoaderContextProvider';
import { VisitsContext } from 'context/VisitsContextProvider';
import AppointmentCard from './AgendaOperator/AppointmentCard';
import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNetwork } from 'services/network';
import translations from 'utils/translations';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { useHistory } from 'react-router-dom';

const CardContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '90%',
  margin: '0 auto',
  maxWidth: 1063,
  paddingBottom: 64,
});

const AgendaOperator = ({ loggedUser, locale }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.Agenda(intl).operator;
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));
  const network = useNetwork();
  const history = useHistory();
  const { setLoaderActive, isLoaderActive } = useContext(LoaderContext);
  const { setAppointments, appointments, setSelectedAppointment } =
    useContext(VisitsContext);
  //Loader Function
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  // States
  const [fecthedAppointments, setFetchedAppointments] = useState([]);

  useEffect(() => {
    const fetchAppointments = async () => {
      showLoader();
      const input = { email: loggedUser.email };
      const res = await network.agendaLambda(input, '/my-appointments');
      const filtered = res.filter((s) => !!s.brandName && !!s.slot);
      setFetchedAppointments(filtered || []);
      setAppointments(filtered || []);
      hideLoader();
    };
    if (loggedUser && !appointments) fetchAppointments();
  }, [loggedUser, appointments]);

  const handleView = (app) => {
    setSelectedAppointment(app);
    history.push('/detail');
  };

  return (
    <Grid container>
      <div style={{ width: '100%' }}>
        {/* <PageHeader i18n={i18n} isBrandPage={false} /> */}
        {/* <div
          style={{
            width: isSmDown ? '90%' : '80%',
            margin: '0 auto',
            maxWidth: 830,
          }}
        >
          <SdmSpacer height={isSmDown ? 20 : 60} />
        </div> */}
        {!isLoaderActive ? (
          <>
            {fecthedAppointments.length ? (
              <Grid item xs={12}>
                <div style={{ backgroundColor: '#F3F3F3' }}>
                  <CardContainer>
                    <SdmSpacer height={isSmDown ? 20 : 60} />
                    {fecthedAppointments
                      .sort(
                        (a, b) =>
                          new Date(b.slot.start) - new Date(a.slot.start)
                      )
                      .map((a, idx) => (
                        <AppointmentCard
                          key={idx}
                          appointment={a}
                          locale={locale}
                          onView={handleView}
                          i18n={i18n}
                          isSmDown={isSmDown}
                          isXsDown={isXsDown}
                        />
                      ))}
                  </CardContainer>
                  <SdmSpacer height={isSmDown ? 50 : 100} />
                </div>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <div style={{ backgroundColor: '#F3F3F3' }}>
                  <SdmSpacer height={isSmDown ? 50 : 100} />
                  <SdmTypography variant={'h1'} textAlign="center">
                    {i18n.noAppointment}
                  </SdmTypography>
                  <SdmTypography variant={'h2Regular'} textAlign="center">
                    {i18n.noAppointmentMsg}
                  </SdmTypography>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                    }}
                  >
                    <CalendarTodayIcon
                      style={{
                        color: 'black',
                        marginTop: 8,
                      }}
                      fontSize="large"
                    />
                  </div>
                  <SdmSpacer height={isSmDown ? 50 : 100} />
                </div>
              </Grid>
            )}
          </>
        ) : null}
      </div>
    </Grid>
  );
};
export default AgendaOperator;
